import stockService from 'stockService'
import utils from 'utils'

export default class receiveBranchInvoiceService {
    constructor($q, httpRequest) {
        this.$q = $q
        this.httpRequest = httpRequest
    }

    // 获取待分配的发票
    async queryAssignedInvoiceBranch(startDate, endDate) {
        const service = this
        const reg = {
            code: /<CODE>(.*?)<\/CODE>/g,
            invoiceType: /<FPZL>(.*?)<\/FPZL>/g,
            invoiceTypeCode: /<LBDM>(.*?)<\/LBDM>/g,
            invoiceNumberStart: /<QSHM>(.*?)<\/QSHM>/g,
            invoiceCount: /<FPFS>(.*?)<\/FPFS>/g,
            invoiceStatus: /<FPZT>(.*?)<\/FPZT>/g,
        }
        const res = await stockService.queryAssignedInvoiceBranch({
            startDate,
            endDate,
        })
        const result = utils.analysisXml(reg, res)
        const response = await service.httpRequest.post_qryReceiveInvoiceList(res)
        result.value.map((val, index) => {
            Object.assign(val, response.data.value && response.data.value[index])
            val.devisionPerson = val.devisionPerson
                ? val.allotOrgName ? `${val.allotOrgName}  ${val.devisionPerson}`
                    : val.devisionPerson : val.allotOrgName
        })
        return await new Promise((resolve, reject) => {
            resolve(result.value)
        })
    }

    // 取盘信息
    async getDiskInfo(diskList) {
        return await new Promise((resolve, reject) => {
            stockService.getDiskInfo().then((res) => { // 获取本地金税盘信息
                res = JSON.parse(res)
                if (res && res.kpfwqh != 0) {
                    const disk = diskList.filter((disk) => disk.diskCode === res.kpfwqh)[0]
                    resolve({ kpfwqh: res.kpfwqh, disk, TaxCode: res.TaxCode })
                } else {
                    reject()
                }
            })
        })
    }

    // 取盘库存来校验服务盘是否真实存在
    async qryServerDiskOfPlugged(diskCodeParam) {
        const service = this
        const response = await service.httpRequest.get_qryServerDiskOfPlugged({ diskCode: diskCodeParam })
        const serverData = response.data.value
        let diskCode = '' // 分票机号
        return await new Promise((resolve, reject) => {
            if (JSON.stringify(serverData) !== '{}' || !serverData) { // 服务器版金税盘返回value不为空对象或者null
                if (serverData.length) {
                    let disk = serverData.filter((data, index, arr) => {
                        data.diskCode === diskCodeParam
                    })
                    disk = disk[0]
                    diskCode = disk.diskCode
                } else diskCode = serverData.diskCode
                if (diskCodeParam != diskCode) {
                    reject(diskCodeParam)
                }
            } else {
                reject(diskCodeParam)
            }
        })
    }

    // 分盘领票
    async downloadInvoiceBranch(data, disk) {
        const res = await stockService.downloadInvoiceBranch(data)
        const service = this
        return await new Promise((resolve, reject) => {
            service.httpRequest.post_receiveAllotInvoice({
                diskCode: disk.diskCode,
                diskName: disk.diskName,
                receiveInvoiceMessage: res,
            }).then((res) => {
                res.data.success ? resolve() : resolve(res.data.message)
            }, () => {
                reject()
            })
        })
    }
}

receiveBranchInvoiceService.$inject = ['$q', 'httpRequest']



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/receiveBranchInvoice/service/ReceiveBranchInvoiceService.js